import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=5704a324"
import script from "./Terminal.vue?vue&type=script&lang=ts"
export * from "./Terminal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports